module.exports = __webpack_public_path__ + "static/talk-3-f08a143875aea49c574e061cfa834d43.png";